module.exports = {
    "collapse": `\xd6sszecsuk\xe1s`,
    "expand": `Kibont\xe1s`
};


//# sourceMappingURL=hu-HU.main.js.map
